import React from 'react'
import PolicyText from './PolicyText.js'

export default function RoomPriceText(props) {

    return (

        <div>
            <small><strong>{props.roomPrice.ratePlanName}</strong></small>

            <PolicyText
                policy={props.roomPrice.cancellationPolicy}
            />

            <PolicyText
                policy={props.roomPrice.depositPolicy}
            />

        </div>

    );
}
